import { render, staticRenderFns } from "./hero-section.vue?vue&type=template&id=031d59ae&scoped=true&"
import script from "./hero-section.vue?vue&type=script&lang=js&"
export * from "./hero-section.vue?vue&type=script&lang=js&"
import style0 from "./hero-section.vue?vue&type=style&index=0&id=031d59ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d59ae",
  null
  
)

export default component.exports